import { useAuthSelector } from 'app/data/auth';
import extensionQueryKeys from 'app/hooks/queries/extension/extensionQueryKeys';
import { sdk } from 'app/sdk';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { ExtensionsPageResponse } from 'types/extension';
import { UsersPageResponse } from 'types/user/UsersPageResponse';

interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  mask?: any;
  options?: Omit<
    UseQueryOptions<
      ExtensionsPageResponse,
      Error,
      ExtensionsPageResponse,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >;
}

export const useListExtensionsQuery = ({
  skip = 0,
  take = 10000,
  orderBy = [['number', 'asc']],
  filters = {},
  mask = '*',
  options,
}: QueryParams) => {
  // returns list of extensions
  // - just get ALL extensions+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = extensionQueryKeys.list(skip, take, orderBy, filters, mask);

  const query = useQuery<ExtensionsPageResponse, Error>(
    queryKey,
    () =>
      sdk.extension.query.extensions(
        {
          skip,
          take,
          orderBy,
          filters,
          mask,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      ...options,
      keepPreviousData: options?.keepPreviousData ?? true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListExtensionsQuery;
